module.exports = __webpack_public_path__ + "img/HZ logo.578c8a80.png";